export default {"src":"/_next/static/media/timer-outline.25933e59.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};